import { render, staticRenderFns } from "./DetailComplain.vue?vue&type=template&id=1304f672&scoped=true&"
import script from "./DetailComplain.vue?vue&type=script&lang=ts&"
export * from "./DetailComplain.vue?vue&type=script&lang=ts&"
import style0 from "./DetailComplain.vue?vue&type=style&index=0&id=1304f672&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1304f672",
  null
  
)

export default component.exports